import { createReducer } from 'Helpers/redux'
import {
  MARK_MOOD_TOOLTIP_AS_READ,
  MARK_LANG_MODAL_AS_SHOWN,
} from '../actions/sessionNotificationsActions'

const initialState = {
  moodTooltipShown: false,
  languageModalShown: false,
}

const handlers = {
  [MARK_MOOD_TOOLTIP_AS_READ]: prevState => ({
    ...prevState,
    moodTooltipShown: true,
  }),
  [MARK_LANG_MODAL_AS_SHOWN]: prevState => ({
    ...prevState,
    languageModalShown: true,
  }),
}

export default createReducer(initialState, handlers)
